export default __webpack_public_path__ + "static/media/jump.0c5c2c5f.mp3";